<template>
	<div>
		<div class="row">
			<div class="mb-3">          
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6">
									<el-form-item label="Branch:">
										<el-select v-model="branch" clearable filterable placeholder="Branch" size="medium" style="width:100%;">
											<el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								
								<div class="col-md-6">
									<!--<ReportParamDateRange title="Date" v-model="date" />-->
									<el-form-item label="Pos Date:">
										<div class="block">
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											size="small" 
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>	
								
								<div class="col-md-6">
									<el-form-item label="Delivery Type">
										<el-radio-group v-model="deliverytype" size="small" name="deliverytype">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.deliverytype" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="false">
									<el-form-item label="Area">
										<el-radio-group v-model="area" size="small" name="area">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								
							</div>

							<div class="row">
								<div class="col-md-6">
									<el-form-item label="Group">
										<el-radio-group v-model="group" size="small" name="group">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.group" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6">
									<el-form-item label="Period">
										<el-radio-group v-model="period" size="small" name="period">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.period" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
								
							<div class="row mt-2">
								<div class="col-md-6">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="row" v-show="tabIndex < 2">
				<div class="col-md-3 mb-3">
					<el-checkbox v-model="showchart">Show Chart</el-checkbox>
				</div>
				<div class="col-md-9 mb-3" v-if="showchart">
					<el-radio-group v-model="charttype">
						<el-radio label="barchart" size="small">Bar Chart</el-radio>
						<el-radio label="linechart" size="small">Line Chart</el-radio>
						<el-radio label="piechart" size="small">Pie Chart</el-radio>
					</el-radio-group>
				</div>

				<div class="col-md-3" v-if="showchart && charttype=='barchart' ">
					<el-checkbox v-model="stacked">Stacked</el-checkbox>
				</div>
				
			</div>
			<div class="mb-0" >
				<BarChart v-loading.body="loading.chart" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
				<LineChart v-loading.body="loading.chart" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
				<PieChart :data="piechartdata" :url="''" v-if="showchart && charttype=='piechart'" style="width:250px;" />
			</div>

			<div class="mt-0">
				<ReportResultTable :reportname="'FuelReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
			</div>
		</div>
	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, Rainbow2, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'

export default
{
	extends: Bright,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: { 
		//ReportParamSelect,
		ReportResultTable,
		LineChart,
		BarChart,
		PieChart,
		//Loader,
	},

	data() {
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			charttype: 'barchart', //barchart //linechart
			urlRequestParams: '',
			dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
			
			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'daily', name: 'DAILY' },
					//{ value: 'weekly', name: 'WEEKLY' },
					{ value: 'monthly', name: 'MONTHLY' },
					{ value: 'yearly', name: 'YEARLY' },
				],
				channel:[
					{ value: "", name: "ALL" }, 
					{ value: "channel", name: "BY CHANNEL" }, 
					{ value: "OTHER", name: "OTHER" }, 
					{ value: "STORE", name: "STORE" }, 
					{ value: "SPBU", name: "SPBU" }, 
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "area", name: "BY AREA" }, 
					{ value: "province", name: "BY PROVINCE" }, 
					{ value: "store", name: "BY BRANCH" }, 
				],
				detail2:[
					{ value: "", name: "ALL" }, 
					{ value: "item", name: "BY ITEM" }
				],
				pso:[
					{ value: "", name: "ALL" }, 
					{ value: "bypso", name: "BY PSO" },
					{ value: "PSO", name: "PSO" },
					{ value: "NONPSO", name: "NON PSO" },
				],
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				source:[
					{ value: "", name: "ALL" }, 
					{ value: "source", name: "BY SOURCE" }, 
					{ value: "KEAGENAN", name: "KEAGENAN" }, 
					{ value: "VENDOR", name: "VENDOR" }, 
				],

				group:[
					{ value: "", name: "ALL" }, 
					{ value: "branch", name: "BY BRANCH" }, 
					{ value: "product", name: "BY PRODUCT" }, 
					{ value: "detail", name: "DETAIL" }, 
				],

				deliverytype: [
					{ value: "", name: "ALL" }, 
					{ value: "PICKUP SERVICE", name: "PICKUP SERVICE" }, 
					{ value: "ONLINE DELIVERY", name: "ONLINE DELIVERY" }, 
				],
			},

			reportdata: [],
			chartdata: [],
			chartresponsedata: [],
			piechartdata: [],
			deliverytype: '',
			group: '',
			showchart: false,
			stacked: true,
			branch: this.$route.query.branch ? this.$route.query.branch : '',
			period: this.$route.query.period ? this.$route.query.period : '', //daily
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			detail2: this.$route.query.detail2 ? this.$route.query.detail2 : '',
			area: this.$route.query.area ? this.$route.query.area : '',
			channel: this.$route.query.channel ? this.$route.query.channel : '',
			pso: this.$route.query.pso ? this.$route.query.pso : 'bypso',
			source: this.$route.query.source ? this.$route.query.source : '',

			loading: {
				table: false,
				chart: false,
				piechart: false,
				isSuccess: false,
			},

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

		}
	},
	watch:
	{
		reportdata() { this.refreshChart(); },
		stacked() { this.refreshChart(); },

	}, 
    mounted()
    {
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		
        this.$emit('childrenRoute');
		this.loadStoreList()
		//this.resumePilihan()
		//this.getBarchart()
		//this.getPiechart()
		
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		refreshChart() {
			//this.chartdata = this.processBarChart(this.reportdata.data, a, "", "TotalSalesExTax", false, b, "", 1000000, 2, c, false, false, false, this.stacked);
			this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);
		},

		resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/merchandise/sales?'
			
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			this.urlRequestParams+='&group='+this.group
			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&deliverytype='+this.deliverytype
			this.urlRequestParams+='&branch='+this.branch

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				this.reportdata = response.data;
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.table = false;
			})

		},

		getBarchart(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/merchandise/sales-barchart?'
			
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&deliverytype='+this.deliverytype
			this.urlRequestParams+='&branch='+this.branch

			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				this.chartresponsedata = response.data.data;
				this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.chart = false;
			})

		},

		getPiechart() {
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/merchandise/sales-piechart?'
			
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&deliverytype='+this.deliverytype
			this.urlRequestParams+='&branchid='+this.branch

			this.loading.piechart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				//this.chartresponsedata = response.data.data;
				//this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);
			
				let responsedata = response.data.data
				
				let item = responsedata
				var warna = []
				let value = [];
				let idx = 0;
				for (var row in item) {
					//add color
					warna[item[row].Tahun] = Rainbow[idx];//'#FFB22E'

					//add value
					let main = {
						transtype: item[row].Tahun, 
						amount: item[row].price,
					};

					value.push(main);
					idx++;
				}

				this.piechartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.piechart = false;
			})

		},
		
		applyFilter() {
			this.resumePilihan()
			this.getBarchart()
			this.getPiechart()
        },
		
		
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>